import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Calendar, ExternalLink } from "lucide-react";
import { TOURNAMENT_INFO, ASSETS } from "../data/tournament";
import RevealEmail from "./RevealEmail";

const Footer = () => {
  const v = TOURNAMENT_INFO.venue;
  return (
    <footer className="relative bg-black border-t border-white/10 mt-20" data-testid="site-footer">
      <div className="absolute inset-0 diagonal-stripes opacity-40 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 pb-12 border-b border-white/10">
          <div className="flex items-end gap-6">
            <img src={ASSETS.logo} alt="Coupe CH" className="hidden sm:block h-32 w-32 object-contain" />
            <div>
              <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tight uppercase leading-none">
                UN TOURNOI. <br />
                <span className="text-[#E60012]">UNE PASSION.</span>
              </h2>
              <p className="mt-4 text-white/60 font-condensed uppercase tracking-[0.25em] text-sm">
                {TOURNAMENT_INFO.subtagline}
              </p>
            </div>
          </div>
          <Link
            to="/horaire"
            data-testid="footer-cta"
            className="inline-flex items-center gap-3 self-start px-6 py-3 bg-[#E60012] hover:bg-[#ff1a30] text-white font-condensed uppercase tracking-[0.18em] text-sm transition-all hover:-translate-y-0.5 clip-tab"
          >
            <Calendar className="w-4 h-4" />
            Voir l'horaire complet
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-10 pt-12">
          <div>
            <div className="flex items-center gap-2 mb-3 text-[#E60012]">
              <img src="/favicon.ico" className="hidden" alt="" />
              <span className="font-condensed uppercase tracking-[0.25em] text-xs">Le tournoi</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              La Coupe CH rassemble les équipes M9 catégories 2017 & 2018 pour trois jours
              d'intensité, d'amitié et de hockey de haut niveau.
            </p>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-3 text-[#E60012]">
              <MapPin className="w-4 h-4" />
              <span className="font-condensed uppercase tracking-[0.25em] text-xs">Aréna</span>
            </div>
            <div className="text-white/80 text-sm font-condensed">{v.name}</div>
            <div className="text-white/60 text-xs mt-1">{v.longName}</div>
            <div className="text-white/60 text-xs mt-2">{v.address}<br/>{v.city}</div>
            <a
              href={v.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center gap-1.5 text-[#E60012] hover:text-white text-xs font-condensed uppercase tracking-[0.2em]"
            >
              Voir sur la carte <ExternalLink className="w-3 h-3" />
            </a>
            <div className="mt-3 text-xs text-white/50">
              3 glaces : Hamelin · Letang · Bâtisseurs
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-3 text-[#E60012]">
              <Mail className="w-4 h-4" />
              <span className="font-condensed uppercase tracking-[0.25em] text-xs">Contact</span>
            </div>
            <ul className="space-y-2 text-white/70 text-sm">
              <li>
                <RevealEmail testid="footer-email" />
              </li>
              <li>1, 2 et 3 Mai 2026</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row gap-3 items-center justify-between text-xs text-white/40 uppercase tracking-[0.25em] font-condensed">
          <span>© 2026 Coupe CH — Tous droits réservés</span>
          <div className="flex items-center gap-4">
            <Link to="/commanditaires" className="hover:text-[#E60012]" data-testid="footer-sponsors-link">
              Commanditaires
            </Link>
            <Link to="/admin/login" className="hover:text-[#E60012]" data-testid="footer-admin-link">
              Admin
            </Link>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-white/10 text-center text-sm sm:text-base text-white/70 normal-case tracking-normal" data-testid="footer-credit">
          Site web réalisé avec <span className="text-[#E60012] text-lg">❤️</span> par
          {" "}
          <a
            href="https://www.lesamouraiduweb.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-[#E60012] transition-colors font-semibold underline underline-offset-4 decoration-[#E60012]/50 hover:decoration-[#E60012]"
          >
            le Samouraï du Web
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
